import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Slider from '@farbenmeer/react-spring-slider';

import BannerSmallImg from 'assets/main_lobby/banner-container-small.png';
import BannerLargeImg from 'assets/main_lobby/banner-container-large.png';

const RootContainer = styled.div`
  background: url(${({ size }) => {
    switch (size) {
      case 'large':
        return BannerLargeImg;
      case 'small':
      default:
        return BannerSmallImg;
    }
  }});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: ${({ size }) => {
    switch (size) {
      case 'large':
        return 349;
      case 'small':
      default:
        return 307;
    }
  }}px;
  width: ${({ size }) => {
    switch (size) {
      case 'large':
        return 540;
      case 'small':
      default:
        return 360;
    }
  }}px;
`;

const SliderContainer = styled.div`
  background-color: #FFF;
  color: #484848;
  margin-top: ${({ size }) => {
    switch (size) {
      case 'large':
        return 60;
      case 'small':
      default:
        return 100;
    }
  }}px;
  height: ${({ size }) => {
    switch (size) {
      case 'large':
        return 280;
      case 'small':
      default:
        return 200;
    }
  }}px;
  width: ${({ size }) => {
    switch (size) {
      case 'large':
        return 540;
      case 'small':
      default:
        return 360;
    }
  }}px;
`;

const AssetContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ size }) => ((size === 'large') ? '0' : '24')}px;
`;

const StyledImg = styled.img`
  flex: 0 0 auto;
  max-height: 100%;
`;

const StyledVideo = styled.video`
  height: 100%;
  width: 100%;
  user-select: all;
  pointer-events: all;
`;

const StyledIframe = styled.iframe`
  height: 100%;
  width: 100%;
  user-select: all;
  pointer-events: all;
`;

const BannerView = ({ className, size, assets }) => (
  <RootContainer className={className} size={size}>
    <SliderContainer size={size}>
      <Slider hasArrows={assets.length > 1}>
        {
          assets.map(({ src, type }, index) => {
            switch (type) {
              case 'embed':
                return (
                  <AssetContainer key={index} size={size}>
                    <StyledIframe src={src} allow="fullscreen" />
                  </AssetContainer>
                );
              case 'video':
                return (
                  <AssetContainer key={index} size={size}>
                    <StyledVideo src={src} controls />
                  </AssetContainer>
                );
              case 'image':
              default:
                return (
                  <AssetContainer key={index} size={size}>
                    <StyledImg src={src} />
                  </AssetContainer>
                );
            }
          })
        }
      </Slider>
    </SliderContainer>
  </RootContainer>
);

BannerView.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']).isRequired,
  assets: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    type: PropTypes.string,
  })),
};

BannerView.defaultProps = {
  assets: [],
  className: null,
};

export default BannerView;
